<template>
  <div class="main_settings_contract card" >
    <div class="content">
      <div v-if="type == 'settings'" class="list_p" v-html="get_word('approve_contract_parts')"></div>
      <div class="contracts_container" v-if="partsComp.length > 0">
        <template v-for="(part, i) in partsComp" :key="part.id">
          <contractPart :index="i" :state="state" @save_clause="saveClause" @update="part = $event" @save_part="savePart" @addClause="addClause($event, part.id)" :partComp="part"  />
        </template>
      </div>
      <div v-else>
        <h4>אין סעיפים לשיפור</h4>
      </div>
      <div class="btn_container" v-if="state === 'edit'">
        <div class="btn" @click="$emit('next')" v-text="type === 'tech' && bid_step === 'improve' ? 'סיום ושלח מכרז' : 'המשך לשלב הבא'"></div>
      </div>
    </div>
  </div>
</template>

<script>
import contractPart from './contractPart.vue';

export default {
  props: {
    token: {
      type: String,
      required: true
    },
    state:{
      type: Object,
      required: false
    },
    type:{
      type: String,
      required: true
    },
    bid_step:{
      type: String,
      required: true
    },
    contractType:{
      type: Object,
      required: true
    }
  },
  components: {contractPart},
  data() {
    return {
      expntionBoxs: [
        'basic_details',
        'details_planes',
        'legal_details'
      ],
      // loaded: false,
      contract: this.contractType,
    }
  },
  mounted() {
    console.log(this.contractType, "this.contractType");
    this.init()
  },
  computed: {
    partsComp() {
      const res = this.contract ? this.filtereParts(this.contract.parts) : [];
      console.log(res, "res");
      return res;
    }
  },
  methods: {
    async saveClause(clause) {
      const { data: clauseData} = await this.api({ action: 'applying/save_clause',data: {token: this.token ,clause }});
      console.log(clauseData, "clauseData");
      // replace the clause in the contract with the new clause
      if(clause.id === null && clauseData)
      {
        const findClauseFunc = (clause) => {
          return clause.clause_id == clauseData.clause_id;
        }
        const setClauseFunc = this.findClauseById(findClauseFunc, this.contract.parts, true);
        if(setClauseFunc) setClauseFunc(clauseData);
      }
    },
    savePart(part) {
      this.api({ action: 'applying/save_part',data: {token: this.token ,part }});
    },
    saveContract() {
      this.api({ action: 'contracts/save', data: {token: this.token, contract: this.contract}}, (data) => {
          if(data.data && data.data.length > 0)
          {
            for (let i = 0; i < data.data.length; i++) {
              this.contract.parts.forEach(part => {
                if(part && part.clauses && part.clauses.length > 0)
                {
                  for (let j = 0; j < part.clauses.length; j++) {
                    if(data.data[i].id === part.clauses[j].id)
                    {
                      part.clauses[j].id = data.data[i].new_id;
                      part.clauses[j].new = false;
                    }
                  }
                }
              });
            }
          }
      });
    },
    toggleBox(boxName) {
        if (this.expntionBoxs.includes(boxName)) this.expntionBoxs = this.expntionBoxs.filter( str => str != boxName)
        else this.expntionBoxs.push(boxName)
    },
    init() {
      if(this.state === 'edit') {
        // this.api({ action: 'applying/get_contract', data: {token: this.token ,type: this.type }}, (data) => {
        //   this.contract = data.data;

        //   if (this.bid_step === 'improve') {
        //     // Filter to only show clauses with notes when in improve mode
        //     this.contract.parts = this.contract.parts.reduce((filteredParts, part) => {
        //       const filteredClauses = part.clauses.filter(clause => clause.notes && clause.notes.length > 0);
              
        //       if (filteredClauses.length > 0) {
        //         filteredParts.push({
        //           ...part,
        //           clauses: filteredClauses.map(clause => ({
        //             ...clause,
        //             edit_mode: false,
        //             show_note: false,
        //             note_edit: false,
        //             content_temp: clause.content
        //           }))
        //         });
        //       }
              
        //       return filteredParts;
        //     }, []);
        //     console.log(this.contract.parts, "this.contract.parts");
        //   } else {
        //     // Normal mode - show all clauses
        //     this.contract.parts = this.contract.parts.map(part => ({
        //       ...part,
        //       clauses: part.clauses.map(clause => ({
        //         ...clause,
        //         edit_mode: false,
        //         show_note: false,
        //         note_edit: false,
        //         content_temp: clause.content
        //       }))
        //     }));
        //   }
          
        //   this.loaded = true;
        // });
      }
      else if(this.state === 'watch') {
        // this.api({ action: 'projects/get_contract', data: {token: this.token ,type: this.type }}, (data) => {
        //   this.contract = data.data;
        //   this.loaded = true;
        // })
      }
    },
    addClause(contentClause, partId) {
      for (let i = 0; i < this.contract.parts.length; i++) {
        if (this.contract.parts[i].id === partId) {
          this.contract.parts[i].clauses.push({id: this.uniqueId(), content: contentClause, content_temp: contentClause, edit_mode: false, pid: partId })
        }
        
      }
    }
  }
}
</script>

<style lang="scss">
.main_settings_contract {
  >.content { display: flex; flex-direction: column; gap: var(--gap_xmid);
    .btn_container { align-self: flex-end;}
  }
  .contracts_container { display: flex; flex-direction: column;  gap: var(--gap);}
}
</style>